import { Badge, Box, Grid, GridItem, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, } from '@chakra-ui/react'
import MyDiv from './attendanceDetailList.style'
import { attendanceHeaders, AttendanceRecord, props } from './modal';
import { CustomToast } from '../../../../components';
import { useFetch } from '../../../../hooks/useFetch';
import { useState } from 'react';
import { showDate } from '../../../../utilities/helper';
import { getStatusClass, getSourceBadgeClass } from '../AttendanceList/modal';

const AttendanceDetailList = ({ attendanceData }: props) => {
  const { addToast } = CustomToast();
  const { fetchApi } = useFetch(addToast);
  const [modelopen, setModelOpen] = useState(false);
  const [punchLogs, setPunchLogs] = useState<any>();
  const [emp, setEmp] = useState<AttendanceRecord | null>(null);

  const handleview = async (emp: AttendanceRecord) => {
    setEmp(emp);
    setModelOpen(true);
    const response = await fetchApi("Hrlense_Attendance/punchLogs", "GET", "", `employeeId=${emp?.employeeId}&date=${emp.startTime.split('T')[0]}`);
    if (response) setPunchLogs(response)
  }

  return (
    <MyDiv>
      <Box>
        <Grid className='grid_container' columnGap={4}>
          <GridItem colSpan={12}>
            <TableContainer mt={4} borderRadius="md" boxShadow="sm" bg="#fff" maxHeight="83vh" overflowY="auto">
              <Table variant='striped' colorScheme='gray' size="sm">
                <Thead className="table_header">
                  <Tr>
                    {attendanceHeaders.map((header) => (
                      <Th key={header.id} className="font-poppins text_medium text_sm" color="#000000" >{header.name}</Th>
                    ))}
                  </Tr>
                </Thead>
                <Tbody>
                  {attendanceData?.records.map((record: any, index: any) => (
                    <Tr key={index}>
                      <Td className='font-poppins text_regular text_sm'>{index + 1}</Td>
                      <Td ><Badge variant="subtle" className="startDate font-poppins text_sm text_regular" onClick={() => { handleview(record); }}>{showDate(record.startTime)}</Badge></Td>
                      <Td className='font-poppins text_regular text_sm'>{record.startTime && record.startTime.split('T')[1] !== "00:00:00" ? record.startTime.split('T')[1] : "--"}</Td>
                      <Td className='font-poppins text_regular text_sm'>{record.endTime ? record.endTime.split('T')[1] : "--"}</Td>
                      <Td className={` ${getStatusClass(record.status)}`}>{record.status_Name}</Td>
                      <Td><Text as="span" className={`font-poppins text_sm text_medium ${getSourceBadgeClass(record.source || 'Automatic')}`}>{record.source || 'Automatic'}</Text></Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          </GridItem>
        </Grid>
      </Box>
      <Modal isOpen={modelopen} onClose={() => { setModelOpen(false); setPunchLogs(null) }} size="lg" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader className="font_dark font-poppins text_lg text_semibold" textAlign={"center"}>Punch Logs  ({showDate(emp?.startTime)})</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {punchLogs?.punchLogs?.length > 0 ? (
              <Table variant="striped" size="sm">
                <Thead>
                  <Tr>
                    <Th>ID</Th>
                    <Th>Punch Time</Th>
                    <Th>Punch Type</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {punchLogs?.punchLogs?.map((log: any, index: number) => (
                    <Tr key={log.id}>
                      <Td>{index + 1}</Td>
                      <Td>{new Date(log.punchTime).toLocaleTimeString()}</Td>
                      <Td>{log.punchType.toUpperCase()}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            ) : (
              <Text textAlign={"center"}>No punches found for this date.</Text>
            )}
          </ModalBody>
        </ModalContent>
      </Modal>
    </MyDiv>
  )
}

export default AttendanceDetailList;
